import React, { useContext } from "react";
import { CreatorContext } from "../../contexts/CreatorContext";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";

function Header() {
	const { creator, pathId } = useContext(CreatorContext);
	const navigate = useNavigate();

	return (
		<div
			style={{
				backgroundImage: creator?.banner
					? `url(${creator?.banner})`
					: (creator?.app?.creatorIframes ?? []).length > 0 &&
					  creator?.app?.creatorIframes[0].banner
					? `url(${creator?.app?.creatorIframes[0].banner})`
					: `linear-gradient(135deg, ${
							creator?.headerColor || "#43BD98"
					  }, #f9fafb)`,
				backgroundSize: "cover",
				backgroundPosition: "center",
				padding: "2rem 1rem",
				textAlign: "center",
				color: "#fff",
				position: "relative",
			}}
		>
			{/* Capa oscura encima del fondo */}
			<div
				style={{
					position: "absolute",
					top: 0,
					left: 0,
					width: "100%",
					height: "100%",
					backgroundColor: "rgba(0, 0, 0, 0.5)",
					zIndex: 1,
				}}
			/>

			{/* Contenido visible sobre la capa */}
			<div
				style={{
					position: "relative",
					zIndex: 2,
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					gap: "0.75rem",
					cursor: "pointer",
				}}
				onClick={() => {
					navigate(`/${pathId}`);
				}}
			>
				{(creator?.logo ||
					(creator?.app?.creatorIframes ?? [{ logo: null }])[0].logo) && (
					<img
						src={
							creator?.logo ??
							(creator?.app?.creatorIframes ?? [{ logo: null }])[0].logo
						}
						alt="Logo"
						style={{
							height: "100px",
							objectFit: "contain",
							//filter: "invert(1)",
						}}
					/>
				)}

				<div
					style={{
						backgroundColor: "rgba(0, 0, 0, 0.35)",
						display: "inline-block",
						padding: "0.75rem 1.5rem",
						borderRadius: "10px",
					}}
				>
					<Typography
						color="textSecondary"
						sx={{
							fontSize: "16px",
							color: "#fff",
							textShadow: "1px 1px 6px rgba(0, 0, 0, 0.6)",
						}}
					>
						Bienvenido a {creator?.app?.name || ""}
					</Typography>
				</div>
			</div>
		</div>
	);
}

export default Header;
